import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from './Admin/Navbar/AdminNavbar';

const AdminLayout = () => {
  return (
    <div className="flex">
      <AdminNavbar />
      <main className="flex-1 overflow-x-hidden md:ml-[256px]">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
